import { defineChain } from "viem";
import { createConfig, createStorage, http } from "wagmi";
import { injected, coinbaseWallet, walletConnect } from "wagmi/connectors";

export const EXPLORER = process.env.REACT_APP_RH_EXPLORER;
export const TESTNET_EXPLORER = process.env.REACT_APP_RH_TESTNET_EXPLORER;
export const WC_PROJECT_ID = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID || "";

export const robinhood = defineChain({
  id: 4663,
  name: "Robinhood Chain",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: { default: { http: [process.env.REACT_APP_RH_MAINNET_RPC] } },
  blockExplorers: { default: { name: "Blockscout", url: EXPLORER } },
  contracts: { multicall3: { address: "0xcA11bde05977b3631167028862bE2a173976CA11" } },
});

export const robinhoodTestnet = defineChain({
  id: 46630,
  name: "Robinhood Chain Testnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: { default: { http: [process.env.REACT_APP_RH_TESTNET_RPC] } },
  blockExplorers: { default: { name: "Blockscout", url: TESTNET_EXPLORER } },
  testnet: true,
});

const origin = window.location.origin;
const appMeta = { name: "HIVEVORA", description: "HIVEVORA — DEX, token listings & launchpad on Robinhood Chain", url: origin, icons: [`${origin}/logo192.png`] };

export const wagmiConfig = createConfig({
  chains: [robinhood, robinhoodTestnet],
  connectors: [
    injected({ shimDisconnect: true }),
    coinbaseWallet({ appName: "HIVEVORA", appLogoUrl: `${origin}/logo192.png`, preference: "eoaOnly" }),
    ...(WC_PROJECT_ID ? [walletConnect({ projectId: WC_PROJECT_ID, metadata: { ...appMeta, redirect: { universal: origin } }, showQrModal: true })] : []),
  ],
  storage: createStorage({ storage: window.localStorage, key: "hive.wagmi" }),
  transports: {
    [robinhood.id]: http(process.env.REACT_APP_RH_MAINNET_RPC),
    [robinhoodTestnet.id]: http(process.env.REACT_APP_RH_TESTNET_RPC),
  },
});

const base = (chainId) => (chainId === robinhoodTestnet.id ? TESTNET_EXPLORER : EXPLORER);
export const txUrl = (h, chainId) => `${base(chainId)}/tx/${h}`;
export const addrUrl = (a, chainId) => `${base(chainId)}/address/${a}`;
export const tokenUrl = (a, chainId) => `${base(chainId)}/token/${a}`;
